export default __webpack_public_path__ + "static/media/Foye Cruise_V.2.45224b93.png";